module.exports = __webpack_public_path__ + "img/modal-image.71807749.png";